export * from './Moon'
export * from './Sun'
export * from './Unicorn'
import { FC, useMemo } from 'react'

import { Moon } from './Moon'
import { Sun } from './Sun'
import { Unicorn } from './Unicorn'

const THEME_ICON: Record<string, ({}: { props?: React.ComponentProps<'svg'> }) => JSX.Element> = {
  dark: Moon,
  light: Sun,
  dank: Unicorn,
}

export const ThemeIcon: FC<any> = ({ theme, ...props }: any) => {
  const Icon = useMemo(() => {
    return THEME_ICON[theme]
  }, [theme])

  if (Icon) return <Icon {...props} />
  return <></>
}
